/**
 * Oval (egg-shape) geometry taken from the Figma design (see assets/all.svg).
 * All values are in design coordinates on a 810×1080 canvas.
 */
export const OVAL_DESIGN_WIDTH = 810
export const OVAL_DESIGN_HEIGHT = 1080

/**
 * The base oval shape. Bounds: x 217.5–592.5 (375 wide), y 355–855 (500 tall).
 * Used both as the mask cutout and as the path the outlines stroke.
 */
export const OVAL_PATH =
  'M405 355C293.916 355 217.5 434.215 217.5 574.178C217.5 714.14 293.915 855 405 855C516.085 855 592.5 714.14 592.5 574.178C592.5 434.215 516.084 355 405 355Z'

export const OVAL_CENTER_X = 405
/** Vertical midpoint of the oval bounds (355–855). */
export const OVAL_CENTER_Y = 605
export const OVAL_PATH_WIDTH = 375
export const OVAL_PATH_HEIGHT = 500
/** Relative vertical position of the oval center on the design canvas. */
export const OVAL_CENTER_Y_RATIO = OVAL_CENTER_Y / OVAL_DESIGN_HEIGHT
